//Technical Support subjects the user can select when creating a support ticket
export const SUPPORT_SUBJECTS = [
  // Account & Access
  'Login & Authentication Issues',
  'Account Settings & Profile',
  // Assessments & Reports
  'Scaleup Readiness Assessment (SRA)',
  // Growth Planning
  'Growth Plan Access',

  // Team Management
  'Inviting Team Members',

  // Platform Features
  'Navigation & UI Issues',
  'Form Submission Errors',
  'Data Not Saving',
  'Page Loading Problems',

  // Integrations
  'Calendar Integration',
  'Google Meet Issues',
  'Email Notifications',

  // General
  'Feature Requests',
  'How-To Questions',
  'General Inquiries',
  'Other',
];
  